<template>
  <div class="v-level --is-level-3 --is-desktop">
    <div id="level3-duplex" class="duplex">
      <div class="row">
        <div class="duplex__left kol-xs-7">
          <Heading title="Selbst zusammenstellen" subtitle="Sie bestimmen jede Delikatesse." level="3" />

          <LevelCatalog
            ref="catalog"
            :listItems="listItems"
          />
        </div>

        <div class="duplex__right kol-xs-5">
          <div class="u-sticky-top" ref="stickySidebar">
            <Composer
              ref="composer"
              v-if="$store.getters.getCurrentLevel"
              :key="$store.getters.getCurrentLevel"
              class="v-level__composer"
              environment="configurator"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { UiMixin } from '@/mixins/UiMixin';
import { getPriceLevel3 } from '@/helper/functions.js';

import Heading from '@/components/Heading';
import LevelCatalog from '@/components/LevelCatalog';
import Composer from '@/components/Composer/Composer';

export default {
  components: {
    Heading,
    LevelCatalog,
    Composer
  },
  mixins: [logicMixin, UiMixin],
  methods: {
    allInList() {
      var allInList = true;
      if (this.$store.getters.getSelectedItem.data !== null) {
        this.$store.getters.getSelectedItem.data.products.forEach(element => {
          var eInList = false;
          this.$store.getters.getListItemsLevel3.forEach(element2 => {
            if (element.id === element2.id) {
              eInList = true;
            }
          });

          if (!eInList) {
            allInList = false;
          }
        });
      }

      return allInList;
    },
    toPostcard() {
      if (this.allInList()) {
        this.$router.push(this.cLink('/Grusskarte'));
      }
    },
    checkScroll () {
      if (window.scrollY > document.querySelector('#header').offsetHeight) {
        this.$refs.composer.$el.style.setProperty('height', `${window.innerHeight - 30}px`);
      } else {
        this.$refs.composer.$el.style.setProperty('height', `${window.innerHeight - document.querySelector('#header').offsetHeight - 30}px`);
      }
    }
  },
  computed: {
    listItems() {
      return this.$store.getters.getListItemsLevel3Filtered.filter((
        product
      ) => {
        const price = getPriceLevel3(product, this.$store.getters.getUserGroupId, !this.$store.getters.getLevel3Filter.useB2cPrices);
        if (
          price >= this.$store.getters.getLevel3Filter.priceMin &&
                  price <= this.$store.getters.getLevel3Filter.priceMax
        ) {
          return true;
        }
        return false;
      });
    }
  },
  mounted () {
    this.checkScroll();

    document.addEventListener('scroll', this.checkScroll);
  },
  destroyed () {
    document.removeEventListener('scroll', this.checkScroll);
  }
};
</script>
